<template>
    <div class="main-layout">
        <AppHeader />
        <main>
            <router-view />
        </main>
        <AppFooter />

        <LoadingOverlay />
        <ConfirmOverlay />
        <NotifyOverlay />
    </div>
</template>



<script setup>
    import { onMounted } from 'vue'

    import AppHeader from '@/components/common/headers/MainHeader.vue'
    import AppFooter from '@/components/common/footers/MainFooter.vue'
    import LoadingOverlay from '@/components/common/overlays/LoadingOverlay.vue'
    import ConfirmOverlay from '@/components/common/overlays/ConfirmOverlay.vue'
    import NotifyOverlay from '@/components/common/overlays/NotifyOverlay.vue'

    onMounted(() => {
        if (window.__n8nChatLoaded) return
        window.__n8nChatLoaded = true

        const script = document.createElement('script')
        script.id = 'n8n-chat-script'
        script.src = 'https://cdn.n8nchatui.com/v1/embed.umd.js'
        script.async = true

        script.onload = () => {
            const Chatbot = window.Chatbot || window.N8NChat
            if (!Chatbot) {
                console.error('n8n Chat UI not found')
                return
            }

            Chatbot.init({
                n8nChatUrl: 'https://n8n.dat3k.tech/webhook/febac164-a805-492f-9826-67f3bd33a5ff/chat',
                metadata: {},
                theme: {
                    button: {
                        backgroundColor: '#e6e6e6',
                        right: 20,
                        bottom: 20,
                        size: 60,
                        iconColor: '#000000',
                        customIconSrc: 'https://img.gotit.vn/compress/brand/1715336370_pS6BH.png',
                        customIconSize: 90,
                        customIconBorderRadius: 15,
                        autoWindowOpen: {
                            autoOpen: false,
                            openDelay: 3,
                        },
                        borderRadius: 'rounded',
                    },
                    tooltip: {
                        showTooltip: false,
                        tooltipMessage: 'Chào mừng bạn đến với HKM Eyewear chatbot!',
                        tooltipBackgroundColor: 'e6e6e6',
                        tooltipTextColor: '#1c1c1c',
                        tooltipFontSize: 13,
                        hideTooltipOnMobile: false,
                    },
                    allowProgrammaticMessage: false,
                    chatWindow: {
                        borderRadiusStyle: 'rounded',
                        avatarBorderRadius: 16,
                        messageBorderRadius: 10,
                        showTitle: true,
                        title: 'HMK EYEWEAR CHATBOT',
                        avatarSize: 32,
                        welcomeMessage:
                            'Chào mừng bạn đến với HKM Eyewear chatbot! Tại đây tôi sẽ hỗ trợ giải đáp và đề xuất các thông tin liên quan đến sản phẩm trong hệ thống!',
                        errorMessage: 'Opps, sometimes the system has errors!',
                        backgroundColor: '#e6e6e6',
                        height: 600,
                        width: 400,
                        fontSize: 14,
                        starterPrompts: [
                            'Sản phẩm mới',
                            'Sản phẩm bán chạy',
                            'Đề xuất sản phẩm cho tôi',
                        ],
                        starterPromptFontSize: 10,
                        renderHTML: true,
                        clearChatOnReload: true,
                        showScrollbar: true,
                        botMessage: {
                            backgroundColor: '#8a8a8a',
                            textColor: '#fafafa',
                            showAvatar: true,
                            avatarSrc:
                                'https://www.svgrepo.com/show/334455/bot.svg',
                            showCopyToClipboardIcon: false,
                        },
                        userMessage: {
                            backgroundColor: '#000000',
                            textColor: '#ffffff',
                            showAvatar: true,
                            avatarSrc:
                                'https://www.svgrepo.com/show/532363/user-alt-1.svg',
                        },
                        textInput: {
                            placeholder: 'Type your query',
                            backgroundColor: '#ffffff',
                            textColor: '#1e1e1f',
                            sendButtonColor: '#f36539',
                            maxChars: 100,
                            maxCharsWarningMessage:
                                'You exceeded the characters limit. Please input less than 100 characters.',
                            autoFocus: false,
                            borderRadius: 6,
                            sendButtonBorderRadius: 50,
                        },
                        // voiceInputConfig: {
                        //     enabled: true,
                        //     maxRecordingTime: 15,
                        //     recordingNotSupportedMessage:
                        //         'To record audio, use modern browsers like Chrome or Firefox that support audio recording',
                        // },
                    },
                },
            })
        }

        document.body.appendChild(script)
    })
</script>